import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: '[find-a-specialist]',
  imports: [],
  templateUrl: './find-a-specialist.component.html',
  styleUrl: './find-a-specialist.component.scss',
  host: {
    id: 'find-a-specialist',
  }
})
export class FindASpecialistComponent implements OnInit, OnDestroy {
  private scriptElement?: HTMLScriptElement;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    // Only run in browser environment
    if (isPlatformBrowser(this.platformId)) {
      // Add a small delay to ensure the DOM is fully rendered
      setTimeout(() => {
        this.loadHealthGradesScript();
      }, 100);
    }
  }

  ngOnDestroy(): void {
    // Clean up the script element when component is destroyed
    if (this.scriptElement && this.scriptElement.parentNode) {
      this.scriptElement.parentNode.removeChild(this.scriptElement);
    }
  }

  private loadHealthGradesScript(): void {
    // Check if script is already loaded
    if (document.getElementById('healthgrades-script')) {
      console.log('Script already loaded, skipping...');
      return;
    }

    // Check if target element exists
    const targetElement = document.getElementById('hghcp');
    if (!targetElement) {
      console.error('Target element #hghcp not found');
      setTimeout(() => this.loadHealthGradesScript(), 500); // Retry
      return;
    }

    console.log('Loading HealthGrades script...');
    this.scriptElement = document.createElement('script');
    this.scriptElement.id = 'healthgrades-script';
    this.scriptElement.src =
      'https://apps.healthgrades.com/hcp-tzield/embed.js';
    this.scriptElement.type = 'text/javascript';

    // Add event listeners for debugging
    this.scriptElement.onload = () => {
      console.log('HealthGrades script loaded successfully');
    };

    this.scriptElement.onerror = (error) => {
      console.error('Failed to load HealthGrades script:', error);
    };

    document.head.appendChild(this.scriptElement);
    console.log('Script element added to head');
  }

  private initializeWidget(): void {
    // Check if the widget target element exists
    const targetElement = document.getElementById('hghcp');
    if (!targetElement) {
      console.error('Widget target element #hghcp not found');
      return;
    }

    console.log('Widget container ready:', targetElement);
  }
}
